"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritsButton = void 0;
var _Button = _interopRequireDefault(require("../../Button"));
var _HowToReg = _interopRequireDefault(require("@mui/icons-material/HowToReg"));
var _react = require("react");
var _styles = require("@mui/styles");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    button: {
      height: function height(_ref) {
        var rowHeight = _ref.rowHeight;
        return "".concat(rowHeight, "px");
      },
      justifyContent: 'start',
      width: '100%',
      paddingLeft: '16px',
      borderRadius: 0
    }
  };
});
var fillOptions = function fillOptions(_ref2) {
  var favorits = _ref2.favorits,
    options = _ref2.options,
    getOptionValue = _ref2.getOptionValue;
  var favoriteSet = new Set(favorits);
  return options.filter(function (option) {
    return favoriteSet.has(getOptionValue(option));
  });
};
var FavoritsButton = exports.FavoritsButton = function FavoritsButton(_ref3) {
  var label = _ref3.label,
    disabled = _ref3.disabled,
    _ref3$favorits = _ref3.favorits,
    favorits = _ref3$favorits === void 0 ? [] : _ref3$favorits,
    options = _ref3.options,
    selectedOptions = _ref3.selectedOptions,
    onChange = _ref3.onChange,
    getOptionValue = _ref3.getOptionValue;
  var classes = useStyles();
  var isToggleFavoritsDisabled = (0, _hooks.useIsToggleFavoritsDisabled)({
    favorits: favorits,
    options: options,
    fillOptions: fillOptions,
    selectedOptions: selectedOptions,
    getOptionValue: getOptionValue
  });
  var handleToggleFavorits = (0, _react.useCallback)(function (_e) {
    var result = fillOptions({
      favorits: favorits,
      options: options,
      getOptionValue: getOptionValue
    });
    onChange(result, {
      close: true
    });
  }, [onChange, fillOptions, favorits, options, getOptionValue]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
    startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_HowToReg["default"], {}),
    color: 'primary',
    onClick: handleToggleFavorits,
    className: classes.button,
    disabled: isToggleFavoritsDisabled() || disabled,
    children: label
  });
};